import { ReactComponent as ToolIcon } from "../../../assets/icons/tool.svg";
import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { useGetMaintenanceStatsQuery } from "../maintenanceApiSlice";

const MaintenanceDashStats = () => {
  const { data, isLoading } = useGetMaintenanceStatsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    skipPollingIfUnfocused: true,
    // pollingInterval: 20000,
  });

  const expenseStat = data?.data ?? {
    total: 0,
    completed: 0,
    pending: 0,
  };

  const cards = [
    {
      label: "Total maintenance",
      value: `${expenseStat.total.toLocaleString()}`,
      icon: <ToolIcon className="h-8 w-8" />,
      index: 0,
    },
    {
      label: "Completed",
      value: `${expenseStat.completed.toLocaleString()}`,
      icon: <ToolIcon className="h-8 w-8" />,
      index: 1,
    },
    {
      label: "In progress",
      value: `${expenseStat.pending.toLocaleString()}`,
      icon: <ToolIcon className="h-8 w-8" />,
      index: 2,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, icon, index }) => (
        <>
          <DashboardCard
            key={index}
            icon={icon}
            value={isLoading ? "0" : value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </>
      ))}
    </div>
  );
};

export default MaintenanceDashStats;
